const AdminUserListing = () => import('@/components/admin/user/Listing')
const AdminUserUpgrade = () => import('@/components/admin/user/Upgrade')
const AdminUserForm = () => import('@/components/admin/user/Form')
const AdminUserFormNew = () => import('@/components/admin/user/FormNew')
const AdminUserDisplay = () => import('@/components/admin/user/Display/Index')
const AdminUserEdit = () => import('@/components/admin/user/Edit')
const HiveListing = () => import('@/components/admin/hive/Listing')
const HiveForm = () => import('@/components/admin/hive/Form')
const HiveEdit = () => import('@/components/admin/hive/Edit')

const EventListing = () => import('@/components/admin/event/listing')
const EventCreate = () => import('@/components/admin/event/create')
const EventEdit = () => import('@/components/admin/event/edit')

const AdminRefCodesListing = () => import('@/components/admin/referral/Listing')
const AdminRefCodesForm = () => import('@/components/admin/referral/Form')
const AdminGivingReferralGoodListing = () => import('@/components/admin/referral/referralGood/Listing')
const AdminGivingReferralGoodAdd = () => import('@/components/admin/referral/referralGood/Add')
const AdminGivingReferralGoodEdit = () => import('@/components/admin/referral/referralGood/Edit')

const AdminMembershipPayments = () => import('@/components/admin/membershipPayments/Listing')
const AdminMembershipPaymentsForm = () => import('@/components/admin/membershipPayments/Form')
const AdminMembershipPaymentsDisplay = () => import('@/components/admin/membershipPayments/Display')
const AdminMembershipPaymentsadd = () => import('@/components/admin/membershipPayments/Addpayment')

const AdminGivingCreditListing = () => import('@/components/admin/giving/credit/Listing')
// const AdminGivingAutomatedListing = () => import('@/components/admin/giving/automated/Listing')
const AdminGivingRecurringListing = () => import('@/components/admin/giving/recurring/Listing')
const AdminGivingRecurringCreate = () => import('@/components/admin/giving/recurring/Form')
const AdminGivingRecurringDetail = () => import('@/components/admin/giving/recurring/Edit')
const AdminGivingCreditForm = () => import('@/components/admin/giving/credit/Form')
const AdminGivingListing = () => import('@/components/admin/giving/Listing')
const AdminGivingForm = () => import('@/components/admin/giving/Form')

const AdminGivingRemittanceListing = () => import('@/components/admin/giving/remittance/Listing')
const AdminGivingRemittanceCreate = () => import('@/components/admin/giving/remittance/Create')

const AdminWCUCreate = () => import('@/components/admin/wcu/Create')
const AdminListWCUUsers = () => import('@/components/admin/wcu/List')

const AdminWCUUserProjectList = () => import('@/components/admin/wcu/project/List')
const AdminWCUUserProjectCreate = () => import('@/components/admin/wcu/project/Create')
const AdminWCUUserProjectEdit = () => import('@/components/admin/wcu/project/Edit')

const AdminBannersListing = () => import('@/components/admin/banners/index')
const AdminAddBanner = () => import('@/components/admin/banners/add')
const AdminEditBanner = () => import('@/components/admin/banners/edit')

const AdminSponsorsListing = () => import('@/components/admin/sponsors/index')
const AdminAddSponsor = () => import('@/components/admin/sponsors/add')
const AdminEditSponsor = () => import('@/components/admin/sponsors/edit')

const AdminProjectDisplayConditions = () => import('@/components/admin/ProjectDisplay/create')
const AdminWCUUserProfile = () => import('@/components/admin/wcu/profile/Form')
const AdminImpactToken = () => import('@/components/admin/impactToken/ImpactToken')
const AdminExpiredToken = () => import('@/components/admin/impactToken/ExpiredTokens')
const AdminEmployeeAccount = () => import('@/components/admin/employeeAccount/employeeManagement')
const AdminIssueEmpAccounts = () => import('@/components/admin/employeeAccount/IssueForm')
const AdminRemoveEmpAccounts = () => import('@/components/admin/employeeAccount/RemoveForm')
const AdminAdditionalEngagement = () => import('@/components/admin/engagement/engagementManagement')
const AdminIssueEngagement = () => import('@/components/admin/engagement/IssueForm')
const BroadcastNotifications = () => import('@/components/admin/BroadcastNotifications/BroadcastNotifications')
const AdminIssueToken = () => import('@/components/admin/impactToken/Form')
const AdminRevokeToken = () => import('@/components/admin/impactToken/FormRevoke')
const AdminWCUUserProjectUpdates = () => import('@/components/admin/wcu/updates/List')
const AdminWCUUserProjectUpdatesEdit = () => import('@/components/admin/wcu/updates/Edit')
const AdminWCUUserProjectChangelog = () => import('@/components/admin/wcu/project/Changelog')

const AdminCreateMilestoneEmail = () => import('@/components/admin/mails/CreateMilestoneEmail')
const AdminEditMilestoneEmail = () => import('@/components/admin/mails/EditMilestoneEmail')
const AdminListMilestoneEmail = () => import('@/components/admin/mails/ListMilestoneEmail')

const AdminWCUUserBundleCreate = () => import('@/components/admin/wcu/project/bundle/Create')
const AdminWCUUserBundleEdit = () => import('@/components/admin/wcu/project/bundle/Edit')

const AdminWCUUserGlobalProjectCreate = () => import('@/components/admin/wcu/project/global/Create')
const AdminWCUUserGlobalProjectEdit = () => import('@/components/admin/wcu/project/global/Edit')

export default [
  {
    path: '/admin/users',
    name: 'users.listing',
    components: {
      admin: AdminUserListing
    }
  },
  {
    path: '/admin/users/upgrade',
    name: 'users.upgrade',
    components: {
      admin: AdminUserUpgrade
    }
  },
  {
    path: '/admin/users/create',
    name: 'users.form',
    components: {
      admin: AdminUserFormNew
    }
  },
  {
    path: '/admin/users/create-new',
    name: 'users.form',
    components: {
      admin: AdminUserForm
    }
  },
  {
    path: '/admin/users/edit/:id',
    name: 'users.edit',
    components: {
      admin: AdminUserEdit
    }
  },
  {
    path: '/admin/hives',
    name: 'hives.listing',
    components: {
      admin: HiveListing
    }
  },
  {
    path: '/admin/hives/create',
    name: 'hives.create',
    components: {
      admin: HiveForm
    }
  },
  {
    path: '/admin/hives/edit/:id',
    name: 'hives.edit',
    components: {
      admin: HiveEdit
    }
  },
  {
    path: '/admin/users/display/:id',
    name: 'users.display',
    components: {
      admin: AdminUserDisplay
    }
  },
  {
    path: '/admin/referrals',
    name: 'referral-codes',
    components: {
      admin: AdminRefCodesListing
    }
  },
  {
    path: '/admin/create',
    name: 'referral-codes.create',
    components: {
      admin: AdminRefCodesForm
    }
  },
  {
    path: '/admin/edit/:id',
    name: 'referral-codes.edit',
    components: {
      admin: AdminRefCodesForm
    }
  },
  {
    path: '/admin/membership-payments',
    name: 'membership-payments',
    components: {
      admin: AdminMembershipPayments
    }
  },
  {
    path: '/admin/membership-payments/filter/:company_id',
    name: 'membership-payments-filter',
    components: {
      admin: AdminMembershipPayments
    }
  },
  {
    path: '/admin/membership-payments/create',
    name: 'membership-payments.create',
    components: {
      admin: AdminMembershipPaymentsForm
    }
  },
  {
    path: '/admin/membership-payments/edit/:id',
    name: 'membership-payments.edit',
    components: {
      admin: AdminMembershipPaymentsForm
    }
  },
  {
    path: '/admin/membership-payments/display/:id',
    name: 'membership-payments.display',
    components: {
      admin: AdminMembershipPaymentsDisplay
    }
  },
  {
    path: '/admin/membership-payments/add/:id',
    name: 'membership-payments.add',
    components: {
      admin: AdminMembershipPaymentsadd
    }
  },
  {
    path: '/admin/giving/credits',
    name: 'admin.giving.credits.listing',
    components: {
      admin: AdminGivingCreditListing
    }
  },
  {
    path: '/admin/referrals-for-good',
    name: 'admin.referral.referrals-for-good',
    components: {
      admin: AdminGivingReferralGoodListing
    }
  },
  {
    path: '/admin/referrals-for-good/create',
    name: 'admin.referral.referrals-for-good.add',
    components: {
      admin: AdminGivingReferralGoodAdd
    }
  },
  {
    path: '/admin/referrals-for-good/edit/:id',
    name: 'admin.referral.referrals-for-good.edit',
    components: {
      admin: AdminGivingReferralGoodEdit
    }
  },
  {
    path: '/admin/giving/credits/create',
    name: 'admin.giving.credits.create',
    components: {
      admin: AdminGivingCreditForm
    }
  },
  {
    path: '/admin/giving',
    name: 'admin.giving.listing',
    components: {
      admin: AdminGivingListing
    }
  },
  {
    path: '/admin/giving-details/:id',
    name: 'admin.giving.details.listing',
    components: {
      admin: AdminGivingListing
    }
  },
  {
    path: '/admin/giving/create',
    name: 'admin.giving.create',
    components: {
      admin: AdminGivingForm
    }
  },
  // {
  //   path: '/admin/giving/automated',
  //   name: 'admin.giving.automated.listing',
  //   components: {
  //     admin: AdminGivingAutomatedListing
  //   }
  // },
  {
    path: '/admin/recurring',
    name: 'admin.giving.recurring.listing',
    components: {
      admin: AdminGivingRecurringListing
    }
  },
  {
    path: '/admin/recurring/create',
    name: 'admin.giving.recurring.create',
    components: {
      admin: AdminGivingRecurringCreate
    }
  },
  {
    path: '/admin/recurring/detail/:sub_id',
    name: 'admin.giving.recurring.edit',
    components: {
      admin: AdminGivingRecurringDetail
    }
  },
  {
    path: '/admin/giving/remittance',
    name: 'admin.giving.remittance.listing',
    components: {
      admin: AdminGivingRemittanceListing
    }
  },
  {
    path: '/admin/giving/remittance/create',
    name: 'admin.giving.remittance.create',
    components: {
      admin: AdminGivingRemittanceCreate
    }
  },
  {
    path: '/admin/wcuuser/create',
    name: 'admin.wcuuser.create',
    components: {
      admin: AdminWCUCreate
    }
  },
  {
    path: '/admin/wcuuser',
    name: 'admin.wcuuser',
    components: {
      admin: AdminListWCUUsers
    }
  },
  {
    path: '/admin/wcuuser/projects',
    name: 'admin.wcuuser.projects',
    components: {
      admin: AdminWCUUserProjectList
    }
  },
  {
    path: '/admin/wcuuser/projects/edit/:user_id/:id',
    name: 'admin.wcuuser.projects.edit',
    components: {
      admin: AdminWCUUserProjectEdit
    }
  },
  {
    path: '/admin/wcuuser/projects/create/:id',
    name: 'admin.wcuuser.projects.create',
    components: {
      admin: AdminWCUUserProjectCreate
    }
  },
  {
    path: '/admin/wcuuser/projects/global/edit/:id',
    name: 'admin.wcuuser.global-projects.edit',
    components: {
      admin: AdminWCUUserGlobalProjectEdit
    }
  },
  {
    path: '/admin/wcuuser/projects/global/create/:id',
    name: 'admin.wcuuser.global-projects.create',
    components: {
      admin: AdminWCUUserGlobalProjectCreate
    }
  },
  {
    path: '/admin/wcuuser/profiles',
    name: 'admin.wcuuser.profiles',
    components: {
      admin: AdminWCUUserProfile
    }
  },
  {
    path: '/admin/wcuuser/display_conditions',
    name: 'admin.wcuuser.display_conditions',
    components: {
      admin: AdminProjectDisplayConditions
    }
  },
  {
    path: '/admin/banner',
    name: 'admin.banners',
    components: {
      admin: AdminBannersListing
    }
  },
  {
    path: '/admin/banner/add',
    name: 'admin.banners.add',
    components: {
      admin: AdminAddBanner
    }
  },
  {
    path: '/admin/banner/edit/:id',
    name: 'admin.banners.edit',
    components: {
      admin: AdminEditBanner
    }
  },
  {
    path: '/admin/impact-token-management',
    name: 'admin.impact.token',
    components: {
      admin: AdminImpactToken
    }
  },
  {
    path: '/admin/expired-token-management',
    name: 'admin.impact.expired.tokens',
    components: {
      admin: AdminExpiredToken
    }
  },
  {
    path: '/admin/team' +
      '-account-management',
    name: 'admin.employee.account',
    components: {
      admin: AdminEmployeeAccount
    }
  },
  {
    path: '/admin/additional' +
      '-engagement',
    name: 'admin.additional.account',
    components: {
      admin: AdminAdditionalEngagement
    }
  },
  {
    path: '/admin/issue-employee-accounts/:id',
    name: 'admin.issue.accounts',
    components: {
      admin: AdminIssueEmpAccounts
    }
  },
  {
    path: '/admin/issue-additional-engagement/:id',
    name: 'admin.issue.engagement',
    components: {
      admin: AdminIssueEngagement
    }
  },
  {
    path: '/admin/remove-employee-accounts/:id',
    name: 'admin.remove.accounts',
    components: {
      admin: AdminRemoveEmpAccounts
    }
  },
  {
    path: '/admin/broadcast-notifications',
    name: 'broadcast.notifications',
    components: {
      admin: BroadcastNotifications
    }
  },
  {
    path: '/admin/issue-external-token',
    name: 'admin.issue.token',
    components: {
      admin: AdminIssueToken
    }
  },
  {
    path: '/admin/revoke-external-token',
    name: 'admin.revoke.token',
    components: {
      admin: AdminRevokeToken
    }
  },
  {
    path: '/admin/wcuuser/project/updates',
    name: 'admin.wcuuser.project.updates',
    components: {
      admin: AdminWCUUserProjectUpdates
    }
  },
  {
    path: '/admin/wcuuser/project/updates/edit/:id',
    name: 'admin.wcuuser.project.updates.edit',
    components: {
      admin: AdminWCUUserProjectUpdatesEdit
    }
  },
  {
    path: '/admin/wcuuser/project/changelog',
    name: 'admin.wcuuser.project.changelog',
    components: {
      admin: AdminWCUUserProjectChangelog
    }
  },
  {
    path: '/admin/emails/create',
    name: 'admin.emails.create',
    components: {
      admin: AdminCreateMilestoneEmail
    }
  },
  {
    path: '/admin/emails/edit/:id',
    name: 'admin.emails.edit',
    components: {
      admin: AdminEditMilestoneEmail
    }
  },
  {
    path: '/admin/emails/list',
    name: 'admin.emails.list',
    components: {
      admin: AdminListMilestoneEmail
    }
  },
  {
    path: '/admin/wcuuser/bundles/create/:id',
    name: 'admin.wcuuser.bundles.create',
    components: {
      admin: AdminWCUUserBundleCreate
    }
  },
  {
    path: '/admin/wcuuser/bundles/edit/:user_id/:id',
    name: 'admin.wcuuser.bundles.edit',
    components: {
      admin: AdminWCUUserBundleEdit
    }
  },
  {
    path: '/admin/events',
    name: 'admin.events.listing',
    components: {
      admin: EventListing
    }
  },
  {
    path: '/admin/events/create',
    name: 'admin.event.create',
    components: {
      admin: EventCreate
    }
  },
  {
    path: '/admin/events/edit/:id',
    name: 'admin.event.edit',
    components: {
      admin: EventEdit
    }
  },
  {
    path: '/admin/sponsors',
    name: 'admin.sponsors',
    components: {
      admin: AdminSponsorsListing
    }
  },
  {
    path: '/admin/sponsors/add',
    name: 'admin.sponsors.add',
    components: {
      admin: AdminAddSponsor
    }
  },
  {
    path: '/admin/sponsors/edit/:id',
    name: 'admin.sponsors.edit',
    components: {
      admin: AdminEditSponsor
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/admin.js